<template>
  <div class="link" @click="onClick">
    {{name}} <span>{{sign}}</span>
  </div>
</template>

<script>

export default {
  name: "button_showmore",
  props: [],
  data() {
    return {
      isOpen: false,
      name: this.$t('button_show_all'),
      sign: '+'
    }
  },
  methods: {
    onClick() {
      this.$data.isOpen = !this.$data.isOpen;

      if (this.$data.isOpen) {
        this.$data.name = this.$t('button_less_show')
        this.$data.sign = '-'
      } else {
        this.$data.name = this.$t('button_show_all')
        this.$data.sign = '+'
      }

      this.$emit('click')
    }
  }
}
</script>

<style scoped>

.link {
  color: #1768a5;
}

.link > span {
  margin-left: 3px;
}

.link:hover {
  text-decoration: underline;
}
</style>


